import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Cookies, withCookies } from 'react-cookie';
import { handleLogout } from '@client/redux/user';

class LogoutButton extends React.PureComponent {
  handleLogout = () => {
    const { dispatch, onLogout, cookies } = this.props;
    dispatch(handleLogout(cookies));
    onLogout();
  };

  render() {
    const { className } = this.props;

    return (
      <button
        onClick={this.handleLogout}
        className={className ? className : ''}
      >
        Logga ut
      </button>
    );
  }
}

LogoutButton.propTypes = {
  onLogout: PropTypes.func,
  className: PropTypes.string,
  dispatch: PropTypes.func,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};

export default withCookies(connect()(LogoutButton));
